import { requester } from '@/api/axios';

import { apiConst, keyConst } from '@/constants';

import { ApiResponse } from '@/interface';
import {
  IOverviewHistoryRequestParams,
  IOverviewHistoryResponse,
  IOverviewRequestParams,
  IOverviewResponse,
} from '@/interface/overview.interface';

export const getOverview = async (params?: IOverviewRequestParams): Promise<ApiResponse<IOverviewResponse>> => {
  const config = {
    method: 'get',
    url: `${apiConst.getOverview}`,
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };

  return await requester(config);
};

export const getOverviewHistory = async (
  params: IOverviewHistoryRequestParams,
): Promise<ApiResponse<IOverviewHistoryResponse>> => {
  const { type, ...queryParams } = params;
  const config = {
    method: 'get',
    url: `${apiConst.getOverviewHistory}/${type}`,
    params: queryParams,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(keyConst.userToken)}`,
      'Content-Type': 'application/json',
    },
  };

  return await requester(config);
};
